import { createVuetify } from 'vuetify';
import { fr, en } from 'vuetify/locale';
import { monacoDark, monacoDefaults, monacoLight } from '@common/plugins/vuetify/MonacoTheme';

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import '@/assets/scss/main.scss';

/**
 * Même charte que le front public : un agent qui bascule d'un écran à l'autre
 * doit reconnaître les mêmes couleurs de statut.
 *
 * Le thème sombre est proposé pour les postes de supervision, souvent en salle
 * peu éclairée.
 */
export default createVuetify({
	locale: { locale: 'fr', fallback: 'fr', messages: { fr, en } },
	theme: {
		defaultTheme: 'monacoLight',
		themes: { monacoLight, monacoDark },
	},
	defaults: {
		...monacoDefaults,
		// Cibles plus compactes qu'en mobilité : on travaille à la souris.
		VBtn: { rounded: 'lg', elevation: 0 },
	},
	icons: { defaultSet: 'mdi' },
});
